"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApprovalProcessDescription = void 0;
const Field_type_1 = require("../../../types/Field.type");
exports.ApprovalProcessDescription = {
    priority: 1,
    label: 'fields.payload.mor_group_answers.approval_process_description.label',
    fallbackLabel: 'What internal approval processes are required in case an individual has been identified as a true PEP and what impact does the PEP status have on the merchant risk score?',
    mandatory: (payload, path) => isMandatory(payload, path),
    disabled: (payload, path) => false,
    applicable: (payload, path) => isApplicable(payload, path),
    applicableDependsOn: ['mor_group_answers.has_pep_screening', 'contract_onboarding_type'],
    type: Field_type_1.FieldType.String,
    trackFieldValueWithAnalytics: false,
};
function isMandatory(payload, path) {
    return payload.mor_group_answers?.has_pep_screening === true
        && (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
function isApplicable(payload, path) {
    return payload.mor_group_answers?.has_pep_screening === true
        && (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
